import React, { Component } from "react";
import { connect } from "react-redux";
import { authActions, ModalActions, utils, HorizontalLoader } from "@mc/mc-legacy";
import * as ProfileActions from "../actions/ProfileActions";
import * as StavUctu from "mc/lib/api/gen/ucty/v1/StavUctu";
import SpravaKontaktuApi from "../api/gen/core/SpravaKontaktuApi";
import KontaktyNotifikaceForm, { validateKontakty } from "../components/profile/KontaktyNotifikaceForm";
import UserProfileApi from "../api/gen/core/UserProfileApi";
import { SubmissionError } from "redux-form";
import CenteredContent from "../components/layout/CenteredContent";
import "./ContactNotificationPage.scss";
import { Card, CardBody, Col, Modal, ModalHeader } from "reactstrap";

type Props = ReturnType<typeof mapStateToProps>;

const ContactNotificationPage: React.FC<Props> = ({ authInfo }) => {
  const [detail, setDetail] = React.useState(undefined);

  React.useEffect(() => {
    const key = authInfo.data.login;
    UserProfileApi.getUserProfile(key).then((res) => {
      setDetail(res);
    });
  }, []);

  const gotoReturnUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = urlParams.get("returnUrl");

    if (returnUrl) {
      window.location.href = returnUrl;
    } else {
      window.location.href = (window as any).appConfig.serverContextPath + "/notifications/noreturnurl";
    }
  };

  return (
    <CenteredContent className={"eosp-page-content"}>
      <Col>
        {!detail && (
          <Card>
            <CardBody>
              <div className={"pb-2"}>Načítání nastavení notifikací</div>
              <HorizontalLoader />
            </CardBody>
          </Card>
        )}
        {detail && (
          <Modal isOpen backdrop className="contact-notification-page-modal modal-lg">
              <ModalHeader>
                  <h5 className="modal-title">Kontakty</h5>
              </ModalHeader>
              <KontaktyNotifikaceForm
                onSubmit={(submit) => {
                  if (!submit.skipSettings) {
                    const errors = validateKontakty(submit.data);

                    if (Object.keys(errors).length > 0) {
                      throw new SubmissionError(errors);
                    }
                  }

                  return SpravaKontaktuApi.updateKontakty(detail.userId, {
                    ...submit.data,
                    skipSettings: submit.skipSettings,
                  });
                }}
                onSubmitSuccess={gotoReturnUrl}
                overovatEmail={detail.overovatEmail}
                overovatTelefon={detail.overovatTelefon}
                onCancel={gotoReturnUrl}
                canSkip={true}
                initialValues={{
                  telefon: detail.telefon,
                  telefonOveren: detail.telefonOveren,
                  telefonNotifikace: detail.telefonNotifikace,
                  email: detail.email,
                  emailOveren: detail.emailOveren,
                  emailNotifikace: detail.emailNotifikace,
                  nezobrazovatNotifikace: detail.nezobrazovatNotifikace,
                }}
              />
          </Modal>
        )}
      </Col>
    </CenteredContent>
  );
};

function mapStateToProps(state) {
  return {
    authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
    userProfileDetail: utils.storeFromArea(state, ProfileActions.USER_PROFILE_DETAIL_AREA),
  };
}

export default connect(mapStateToProps)(ContactNotificationPage);
